<template>
    <contract-electronic
        v-if="isRender"
        :isFilled="isFilled"
        :contractLink="main"
        :edoTypes="types"
        :is-fetched="typesIsFetched"
        @choose="chooseEdo"
    />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ContractElectronic from './ContractElectronic';

export default {
    name: 'contract-electronic-container',
    components: {
        ContractElectronic,
    },
    methods: {
        ...mapActions('edoTypes', ['fetchEdoTypes', 'chooseEdo']),
    },
    created() {
        if (!this.typesIsFetched) {
            this.fetchEdoTypes();
        }
    },
    computed: {
        ...mapState('contract', ['main']),
        ...mapGetters('edoTypes', {
           typesIsFetched: 'isFetched' 
        }),
        ...mapState('edoTypes', ['types']),
        ...mapState('profile', ['profile', 'isFetched', 'contractStatusIsSigned']),
        ...mapGetters('profile', ['isFilled']),
        isRender() {
            return this.isFetched && !this.contractStatusIsSigned;
        }
    }
}
</script>


// WEBPACK FOOTER //
// ContractElectronicContainer.vue?39d955a8